export enum BundleCourseTypeEnum {
  ELECTIVE = 'ELECTIVE',
  PREREQUISITE = 'PREREQUISITE',
  REQUIRED = 'REQUIRED',
  OTHER = 'OTHER',
}
